import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Container = styled(Box)`
  gap: 6px;
`
